export const SET_SEARCH = 'GROUP_TEMPLATES/CONFIG/SET_SEARCH';
export const SET_SORT = 'GROUP_TEMPLATES/CONFIG/SET_SORT';

export const OPEN_CREATE_TEMPLATE_MODAL = 'GROUP_TEMPLATES/MODAL/OPEN';
export const HIDE_CREATE_TEMPLATE_MODAL = 'GROUP_TEMPLATES/MODAL/HIDE';
export const CREATE_TEMPLATE_FROM_GROUP_REQUEST = 'GROUP_TEMPLATES/CREATE_FROM_GROUP/REQUEST';
